import { modTypes } from "@blings/blings-player";

export const TRIM_EXTEND_TYPE = "trimExtend" as modTypes;

const modTypeValues = Object.values(modTypes) as modTypes[];

export const MOD_TYPE_VALUES_WITH_TRIM_EXTEND = modTypeValues.includes(
  TRIM_EXTEND_TYPE
)
  ? modTypeValues
  : [...modTypeValues, TRIM_EXTEND_TYPE];

export type TrimExtendModData = {
  type: typeof TRIM_EXTEND_TYPE;
  ip?: number;
  op?: number;
};
